<app-document-type-details></app-document-type-details>
